export default "__VITE_ASSET__DiEUPP4m__"